import styled from 'styled-components';
import path from 'ramda/es/path';
import { colors } from '../../theme/styled';
import { H2 } from '../../theme/layout';
import { Text as TextComponent } from '../text';
import { Button, BUTTON_RED } from '../button/button.component';
import { Image } from '../image';
import { fillAbsolute } from '../../theme/mixins';
import { title, text } from '../../theme/typography';
import { media, sizes } from '../../theme/media';
import { CloseButton as CloseButtonComponent } from '../closeButton';

export const Theme = {
  FORM: {
    background: colors.white,
    textColor: colors.darkGrey,
    buttonType: null,
    closeIconMobileColor: colors.darkGrey,
    closeIconDesktopColor: colors.darkGrey,
  },
  LIGHT: {
    background: colors.white,
    textColor: colors.darkGrey,
    buttonType: null,
    closeIconMobileColor: colors.white,
    closeIconDesktopColor: colors.darkGrey,
  },
  DARK: {
    background: colors.darkGrey,
    textColor: colors.white,
    buttonType: BUTTON_RED,
    closeIconMobileColor: colors.white,
    closeIconDesktopColor: colors.white,
  },
};

export const IMAGE_SIZES = {
  [sizes.mobile]: 327,
  [sizes.tabletLarge]: 440,
};

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
`;

export const ScrollWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
`;

export const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: table;
  padding-top: 40px;
  padding-bottom: 40px;
`;

export const FormContent = styled.section`
  ${media.tabletLarge`
    width: 50%;
    flex-shrink: 0;
  `};
`;

export const Content = styled.section`
  padding: 28px 28px 41px;
  text-align: center;

  ${media.tabletLarge`
    width: 50%;
    flex-shrink: 0;
    text-align: left;
    padding: 60px;
  `};
`;

export const Header = styled(H2)`
  ${title};
  font-size: 28px;
  font-weight: bold;
  letter-spacing: 1px;

  ${media.tabletLarge`
    font-size: 36px;
    line-height: 1.17;
  `};
`;

export const Text = styled(TextComponent)`
  margin-top: 8px;
  ${text};

  ${media.tabletLarge`
    margin-top: 15px;
  `};
`;

export const ContentWrapper = styled.div`
  display: table-cell;
  width: 100%;
  vertical-align: middle;
`;

export const Container = styled.article`
  position: relative;
  background-color: ${path(['theme', 'background'])};
  transform: translateZ(1px);
  width: 100vw;
  max-width: 327px;
  min-height: 350px;
  margin-left: auto;
  margin-right: auto;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);

  ${Header}, ${Text} {
    color: ${path(['theme', 'textColor'])};
  }

  ${media.tabletLarge`
    max-width: 80vw;
    min-height: 75vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  `};
`;

export const CtaButton = styled(Button)`
  margin-top: 16px;
  margin-right: 10px;
  flex-grow: 1;
  min-width: 0;
  display: inline-flex;
  justify-content: center;

  ${media.tabletLarge`
    margin-top: 30px;
  `};
`;

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const Figure = styled.figure`
  width: 100%;
  height: 200px;
  position: relative;
  margin: 0;
  display: ${props => (props.withForm ? 'none' : 'block')};

  ${media.tabletLarge`
    display: block;
    width: 50%;
    flex-shrink: 0;
    align-self: stretch;
    height: auto;
  `};
`;

export const FigureImage = styled(Image)`
  ${fillAbsolute};
  object-fit: cover;
`;

export const CloseButton = styled(CloseButtonComponent)`
  position: absolute;
  top: 8px;
  right: 10px;
  background: transparent;
`;
